import { createContext } from 'react';

import { type SearchBoxProps } from './SearchBox';

export const SearchBoxContext = createContext<SearchBoxProps>({});
